<template>
  <span
    v-if="customisedProduct.isLimitedEdition || customisedProduct.hasLimitedEditionPart"
    :class="$b('highlight', { 'limited-edition': customisedProduct.isLimitedEdition })"
  >
    Limited Edition
  </span>
  <span v-else-if="frameAndLens && !customisedProduct.state.customised" :class="$b('highlight')">
    Bestseller
  </span>
  <span v-else-if="customisedProduct.state.customised" :class="$b('highlight', { custom: true })">
    Custom
  </span>
  <span v-if="frameAndLens">
    {{ frameAndLens }}
  </span>
</template>

<script>
export default {
  name: 'ProductDescription',

  props: {
    customisedProduct: {
      type: Object,
      default: () => ({}),
    }
  },

  computed: {
    frameAndLens() {
      if (this.customisedProduct.hasLimitedEditionPart) {
        if(this.customisedProduct.subTitle) return this.customisedProduct.subTitle

        return Object.values(this.customisedProduct.choices).find(
          (choice) => choice.isLimitedEdition
        ).name
      } else if (this.customisedProduct.isLimitedEdition) {
        // Show the limited edition product name
        if(this.customisedProduct.subTitle) return this.customisedProduct.subTitle

        // Show the limited edition part name
        if (this.customisedProduct.hasLimitedEditionPart) {
          return Object.values(this.customisedProduct.choices).find(
            (choice) => choice.isLimitedEdition
          ).name
        }
      }

      if (this.customisedProduct?.frameChoice?.name && this.customisedProduct?.lensChoice?.nameWithoutLensTech) {
        return `${this.customisedProduct?.frameChoice?.name} with ${this.customisedProduct?.lensChoice?.nameWithoutLensTech}`
      }

      return ''
    }
  },
}
</script>

<style lang="postcss">
.ProductDescription__highlight--custom {
  @apply t-gradient-custom;
}

.ProductDescription__highlight--limited-edition {
  @apply t-gradient;
}

.ProductDescription__highlight {
  @apply font-semibold;
}
</style>